import { api } from '../../../lib/api'

export const GET_STORIES_REQUEST = 'GET_STORIES_REQUEST'
export const GET_STORIES_SUCCESS = 'GET_STORIES_SUCCESS'
export const GET_STORIES_FAILED = 'GET_STORIES_FAILED'

export const getStories = function () {
  return function (dispatch) {
    dispatch({
      type: GET_STORIES_REQUEST
    })
    return api.getStories().then((response) => {
      dispatch({
        type: GET_STORIES_SUCCESS,
        payload: response
      })
    }).catch((error) => {
      dispatch({
        type: GET_STORIES_FAILED,
        error
      })
    })
  }
}

export const GET_STORIES_REQUESTS_REQUEST = 'GET_STORIES_REQUESTS_REQUEST'
export const GET_STORIES_REQUESTS_SUCCESS = 'GET_STORIES_REQUESTS_SUCCESS'
export const GET_STORIES_REQUESTS_FAILED = 'GET_STORIES_REQUESTS_FAILED'

export const getStoryRequests = function () {
  return function (dispatch) {
    dispatch({
      type: GET_STORIES_REQUESTS_REQUEST
    })
    return api.getStoryRequests().then((response) => {
      dispatch({
        type: GET_STORIES_REQUESTS_SUCCESS,
        payload: response
      })
    }).catch((error) => {
      dispatch({
        type: GET_STORIES_REQUESTS_FAILED,
        error
      })
    })
  }
}


export const NEW_STORY_REQUEST = 'NEW_STORY_REQUEST'
export const NEW_STORY_SUCCESS = 'NEW_STORY_SUCCESS'
export const NEW_STORY_FAILED = 'NEW_STORY_FAILED'

export const addStory = (data, onComplete) => (dispatch) => {
  dispatch({
    type: NEW_STORY_REQUEST
  })
  return api.addStory(data).then((response) => {
    dispatch({
      type: NEW_STORY_SUCCESS,
      payload: response
    })
    if (onComplete) onComplete()
  }).catch((error) => {
    dispatch({
      type: NEW_STORY_FAILED,
      error
    })
  })
}

export const GET_STORY_REQUEST = 'GET_STORY_REQUEST'
export const GET_STORY_SUCCESS = 'GET_STORY_SUCCESS'
export const GET_STORY_FAILED = 'GET_STORY_FAILED'

export const getStory = function (storyId) {
  return function (dispatch) {
    dispatch({
      type: GET_STORY_REQUEST
    })
    return api.getStory(storyId).then((getStoryResponse) => {
      dispatch({
        type: GET_STORY_SUCCESS,
        payload: getStoryResponse
      })
    }).catch((error) => {
      dispatch({
        type: GET_STORY_FAILED,
        error
      })
    })
  }
}

export const UPDATE_STORY_REQUEST = 'UPDATE_STORY_REQUEST'
export const UPDATE_STORY_SUCCESS = 'UPDATE_STORY_SUCCESS'
export const UPDATE_STORY_FAILED = 'UPDATE_STORY_FAILED'

export const updateStory = function (data, storyId, onComplete) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_STORY_REQUEST,
      payload: { ...data, _id: storyId }
    })
    return api.updateStory(data, storyId).then((getStoryResponse) => {
      dispatch({
        type: UPDATE_STORY_SUCCESS,
        payload: getStoryResponse
      })
      if (onComplete) onComplete()
    }).catch((error) => {
      dispatch({
        type: UPDATE_STORY_FAILED,
        error
      })
    })
  }
}

export const DELETE_STORY_REQUEST = 'DELETE_STORY_REQUEST'
export const DELETE_STORY_SUCCESS = 'DELETE_STORY_SUCCESS'
export const DELETE_STORY_FAILED = 'DELETE_STORY_FAILED'

export const deleteStory = function (storyId, onComplete) {
  return function (dispatch) {
    dispatch({
      type: DELETE_STORY_REQUEST
    })
    return api.deleteStory(storyId).then((deleteStoryResponse) => {
      dispatch({
        type: DELETE_STORY_SUCCESS,
        payload: deleteStoryResponse
      })
      if (onComplete) onComplete()
    }).catch((error) => {
      dispatch({
        type: DELETE_STORY_FAILED,
        error
      })
    })
  }
}

export const STORIES_CLEAR_ERRORS = "STORIES_CLEAR_ERRORS";
export const clearErrors = function () {
  return function (dispatch) {
    dispatch({
      type: STORIES_CLEAR_ERRORS
    })
  }
}

export const STORIES_CLEAR_SECTION_ERROR_FIELD = "STORIES_CLEAR_SECTION_ERROR_FIELD";
export const clearErrorField = function (sectionId, field) {
  return function (dispatch) {
    dispatch({
      type: STORIES_CLEAR_SECTION_ERROR_FIELD,
      payload: {
        field,
        sectionId
      }
    })
  }
}


export const STORIES_ADD_ERRORS = "STORIES_ADD_ERRORS";
export const addErrors = function (errors) {
  return function (dispatch) {
    dispatch({
      type: STORIES_ADD_ERRORS,
      payload: errors
    })
  }
}

export const STORIES_PAGINATE_DATA_CHANGE = 'STORIES_PAGINATE_DATA_CHANGE';

export const storiesPaginateDataChanged = paginateData => (dispatch) => {
  dispatch({
    type: STORIES_PAGINATE_DATA_CHANGE,
    payload: paginateData
  });
}



// WEBPACK FOOTER //
// ./src/redux/actions/stories/stories.js